import React from 'react';
import { Field } from 'redux-form';
import { required, rangeConsolidationAmount } from '../../../utils/validate';
import { formatAmount, toNumber } from '../../../utils/formatters';
import LoanPurposeField from './loanPurposeField';
import { prop } from 'ramda';
import Input from '../../Forms/Input/input';
import PropTypes from 'prop-types';

export const validateConsolidateAmount = (value, allValues) => {
  return rangeConsolidationAmount(Number(allValues.loanAmount), value);
};

const consolidationAmountLabels = [
  {
    "value": "DEBT_CONSOLIDATION",
    "label": "Amount for Debt Consolidation"
  },
  {
    "value": "REFINANCING_CREDIT_CARDS",
    "label": "Amount for Refinancing Credit Cards"
  }
];

const LoanPurposeFieldSet = (props) => {
  const { value } = props;
  const consolidationAmountLabel = prop('label', consolidationAmountLabels.find(type => type.value === value));

  return (
    <fieldset className="container">
      <legend className="row">Purpose</legend>
      <div className="row">
        <div className="col-12 col-lg-6">
          <LoanPurposeField />
        </div>
        { consolidationAmountLabel &&
        <div className="col-12 col-lg-6">
          <Field
            name="consolidationAmount"
            label={consolidationAmountLabel}
            component={Input}
            type="text"
            validate={[required, validateConsolidateAmount]}
            required={true}
            format={formatAmount}
            normalize={toNumber}
          />
        </div>}
      </div>
    </fieldset>);
};

export default LoanPurposeFieldSet;

LoanPurposeFieldSet.propTypes = {
  value: PropTypes.string
};
